export * from '@primeuix/themes/nora/slider';
export { default } from '@primeuix/themes/nora/slider';
